export default __webpack_public_path__ + "static/media/N2P_1864.07215a4e.jpg";